import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg12Styles = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "12 Styles" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "24x24px---NoNo-Def-No-Frame-&-Header-Color",
			transform: "translate(-267.000000, -68.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Portrait",
				transform: "translate(53.000000, 68.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "12-Styles",
					transform: "translate(214.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Frame-for-Icon",
						x: 0,
						y: 0,
						width: 24,
						height: 24
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Icon",
						transform: "translate(1.000000, 1.000000)",
						fill: "#8C9BA8",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "row-1",
								transform: "translate(0.000000, 16.000000)",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 18,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 12,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 6,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 0,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "row-1",
								transform: "translate(0.000000, 8.000000)",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 18,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 12,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 6,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 0,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "row-1",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 18,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 12,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 6,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										x: 0,
										y: 0,
										width: 4,
										height: 6,
										rx: .15
									})
								]
							})
						]
					})]
				})
			})
		})
	})]
});
export { Svg12Styles as ReactComponent };
